import { useCallback, useContext } from 'react';
import AppliedFiltersContext from '~/contexts/AppliedFiltersContext';
import {
  booleanFacets,
  type FacetBooleanKeys,
  type FacetListKeys,
  type FacetRangeKeys,
  listFacets,
  rangeFacets,
  type Tag
} from './constants';

type RemoveTagFunction = () => void;

function isBooleanFacet(facetKey: any): facetKey is FacetBooleanKeys {
  return booleanFacets.includes(facetKey);
}

function isListFacet(facetKey: any): facetKey is FacetListKeys {
  return listFacets.includes(facetKey);
}

function isRangeFacet(facetKey: any): facetKey is FacetRangeKeys {
  return rangeFacets.includes(facetKey);
}

const useRemoveFilterTag = ({ facetKey, context }: Tag): RemoveTagFunction => {
  const {
    updateAvailabilityFilter,
    updateBooleanFilter,
    updateListFilter,
    updateMakes,
    updateRangeFilter
  } = useContext(AppliedFiltersContext);

  return useCallback(() => {
    const isAvailability = facetKey === 'earliestDayToDeliveryOrPickup';
    if (isAvailability) {
      updateAvailabilityFilter({});
    }

    if (isBooleanFacet(facetKey)) {
      updateBooleanFilter({
        filterKey: facetKey,
        value: false
      });
    }

    if (isListFacet(facetKey)) {
      updateListFilter({
        filterKey: facetKey,
        value: context.key
      });
    }

    if (isRangeFacet(facetKey)) {
      updateRangeFilter({
        filterKey: facetKey,
        value: {}
      });
    }

    if (facetKey === 'makes') {
      updateMakes({ name: context.key, parents: context.parents });
    }
  }, [
    context,
    facetKey,
    updateAvailabilityFilter,
    updateBooleanFilter,
    updateListFilter,
    updateRangeFilter,
    updateMakes
  ]);
};

export default useRemoveFilterTag;
